import React from 'react';
import Description from './NewProductPage/Description';
import settings from '@/settings';

export default function MoreProductInfo(props: {
  psku: string;
  description?: string;
  title: string;
  category?: string | undefined;
}) {
  const { psku, description, title, category } = props;
  const warningCategory = [
    'E-scooters',
    'E-skateboards',
    'Electric Bikes',
    'Hoverboards',
    'Hoverboard Bundle',
  ];

  const shouldShowDisclaimer =
    settings.store === 'reebelo-au' &&
    category &&
    warningCategory.includes(category);

  return (
    <div key={psku}>
      {(description || shouldShowDisclaimer) && (
        <div className="relative z-0 py-8">
          {description && (
            <>
              <h2 className="text-lg font-semibold md:text-xl">{title}</h2>
              <Description description={description} />
            </>
          )}
          {shouldShowDisclaimer && (
            <>
              <h2 className="mt-5 font-bold">Warning: Read Before Purchase</h2>
              <p>
                Each state and territory in Australia has different rules and
                regulations pertaining to the use of e-scooters and other
                electric mobility devices (including e-bikes,
                hoverboards/e-skateboards, and go karts), including where you
                can legally use such products, and if you need to register them
                with your state's road traffic authority. It is the
                responsibility of each user to check and abide by their local
                road traffic laws before riding. Exercise caution and always
                wear a helmet and protective gear when riding.
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
}
